// extracted by mini-css-extract-plugin
export default {"detailsButton":"TableItem_detailsButton__DPfLR","icon":"TableItem_icon__gldNG","alignCenter":"TableItem_alignCenter__uImm1","clickable":"TableItem_clickable__lOYso"};